<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-layout row wrap>
            <v-flex lg3 md12 sm12 pr-6 mt-4 pl-lg-6>
                <mh-date-picker plabel="Từ ngày" v-model="dateRange.startDate" @onChangeDate="dateRange.startDate =$event"></mh-date-picker>
            </v-flex>
            <v-flex lg3 md12 sm12 pr-6 mt-4>
                <mh-date-picker plabel="Đến ngày" v-model="dateRange.endDate" @onChangeDate="dateRange.endDate =$event"></mh-date-picker>
            </v-flex>
            <v-flex lg3 md12 sm12 pr-6 pt-0>
                <v-select :items="reportType" item-value="value" item-text="name" v-model="selectedReportType" label="Loại báo cáo"></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="summaryHeader">
              <v-flex class="lg-finance">
                <v-card>
                  <v-app-bar flat dense class="dashboard_widget" @click="gotoDetail('ban-hang')">
                    <i class="fa fa-shopping-cart" aria-hidden="true" style="color: #0dac50"></i>
                    <v-spacer></v-spacer>
                    <v-toolbar-title>
                        <h4>Bán hàng</h4>
                    </v-toolbar-title>
                  </v-app-bar>
                  <v-card-text>
                      <h4>{{ summaryHeader.total_order | currency}}</h4>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex class="lg-finance">
                <v-card>
                  <v-app-bar flat dense class="dashboard_widget" @click="gotoDetail('xuat-hang')">
                    <i class="fa fa-paper-plane" aria-hidden="true" style="color: #ff8030"></i>
                    <v-spacer></v-spacer>
                    <v-toolbar-title>
                        <h4>Xuất hàng</h4>
                    </v-toolbar-title>
                  </v-app-bar>
                  <v-card-text>
                      <h4>{{ summaryHeader.total_receipt | currency}}</h4>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex class="lg-finance">
                <v-card>
                  <v-app-bar flat dense class="dashboard_widget" @click="gotoDetail('tra-hang')">
                    <i class="fa fa-undo" aria-hidden="true" style="color: red"></i>
                    <v-spacer></v-spacer>
                    <v-toolbar-title>
                        <h4>Trả hàng</h4>
                    </v-toolbar-title>
                  </v-app-bar>
                  <v-card-text>
                      <h4>{{ summaryHeader.total_return | currency}}</h4>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex class="lg-finance">
                <v-card>
                  <v-app-bar flat dense class="dashboard_widget" @click="gotoDetail('thanh-toan')">
                    <i class="fa fa-money" aria-hidden="true" style="color: green"></i>
                    <v-spacer></v-spacer>
                    <v-toolbar-title>
                        <h4>Thanh toán</h4>
                    </v-toolbar-title>
                  </v-app-bar>
                  <v-card-text>
                      <h4>{{ summaryHeader.total_payment | currency}}</h4>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex class="lg-finance">
                <v-card>
                  <v-app-bar flat dense class="dashboard_widget" @click="gotoDetail('khach-hang')">
                    <i class="fa fa-credit-card" aria-hidden="true" style="color: #ff8030"></i>
                    <v-spacer></v-spacer>
                    <v-toolbar-title>
                        <h4>Công nợ</h4>
                    </v-toolbar-title>
                  </v-app-bar>
                  <v-card-text>
                      <h4>{{ summaryHeader.total_debt | currency}}</h4>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
        </v-flex>
        <v-flex lg12 md12 sm12 xs12 mt-4>
            <v-layout row wrap>
                <v-flex lg12 md12 sm12 xs12>
                  <highcharts :options="orderChart"></highcharts>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex lg12 md12 sm12 xs12 mt-4>
            <v-layout row wrap>
                <v-flex lg12 md12 sm12 xs12>
                  <highcharts :options="receiptReturnChart"></highcharts>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex lg12 md12 sm12 xs12 mt-4>
            <v-layout row wrap>
                <v-flex lg12 md12 sm12 xs12>
                  <highcharts :options="paymentChart"></highcharts>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex lg12 md12 sm12 xs12 mt-4>
            <v-layout row wrap>
                <v-flex lg12 md12 sm12 xs12>
                  <highcharts :options="topProductChart"></highcharts>
                </v-flex>
            </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import configs from '@/configs';
import {Chart} from 'highcharts-vue';
import MHDatePicker from "@/components/daterange/MHDatePicker";
import _ from "lodash";
import moment from "moment"
export default {
  components: {
    highcharts: Chart,
    "mh-date-picker": MHDatePicker
  },
  data() {
    return {
      dateRange: {
        startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
        endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
      },
      menuStart: false,
      menuEnd: false,
      selectedReportType: 1,
      reportType: [
        {value: 1, name: 'Theo doanh thu'},
        {value: 2, name: 'Theo số sản phẩm'},
        {value: 3, name: 'Theo số đơn'}
      ],
    }
  },
  watch: {
    filter_params() {
      this.refresh_report();
    }
  },
  computed: {
    ...mapState({
      summaries: state => state.reports.summary.data,
      top_products: state => state.reports.top_product.data,
      loading: state => state.reports.loading,
    }),
    adminRole() {
      return this.$store.state.authentication.user.role == configs.ROLE_TYPE.Admin;
    },
    filter_params() {
      return {
          pagination: this.pagination,
          'report_type': this.selectedReportType, 
          'start_date': moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT), 
          'end_date': moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT)
      };
    },
    summaryHeader() {
      if(this.selectedReportType == 1) {
        return {
          'total_order': _.sumBy(this.summaries, 'total_order_amount'),
          'total_receipt': _.sumBy(this.summaries, 'total_receipt_amount'),
          'total_return': _.sumBy(this.summaries, 'total_return_amount'),
          'total_payment': _.sumBy(this.summaries, 'total_payment'),
          'total_debt': _.sumBy(this.summaries, 'total_debt'),
        };
      }
      else if(this.selectedReportType == 2) {
        return {
          'total_order': _.sumBy(this.summaries, 'total_order_qty'),
          'total_receipt': _.sumBy(this.summaries, 'total_receipt_qty'),
          'total_return': _.sumBy(this.summaries, 'total_return_qty'),
          'total_payment': _.sumBy(this.summaries, 'total_payment'),
          'total_debt': _.sumBy(this.summaries, 'total_debt'),
        };
      }
      else {
        return {
          'total_order': _.sumBy(this.summaries, 'total_order'),
          'total_receipt': _.sumBy(this.summaries, 'total_receipt'),
          'total_return': _.sumBy(this.summaries, 'total_return'),
          'total_payment': _.sumBy(this.summaries, 'total_payment'),
          'total_debt': _.sumBy(this.summaries, 'total_debt'),
        };
      }
    },
    receiptReturnChart() {
      let dataChart =  _.sortBy(this.summaries,'report_date');
        let ret = {
          chart: { type: 'column' },
          title: { text: 'Xuất & trả hàng' },
          credits: { enabled: false },
          tooltip: {
            shared: true, 
            formatter: function () {
              return parseFloat(this.y.toFixed(2)).toLocaleString();
            }
          },
          xAxis: {
              categories: _.map(dataChart, function(x) {return x.report_date.toString().replace(/(\d{4})(\d{2})(\d{2})/, "$3-$2-$1")})
          },
          yAxis: {
              title: {
                  text: 'Số sản phẩm'
              }
          },
          plotOptions: {
            line: {
              dataLabels: {
                  enabled: true
              }
            },
            series: {
              pointWidth: 30
            }
          },
          series: [
              { 
                  name: 'Xuất hàng',
                  data: _.map(dataChart, 'total_receipt_qty')
              },
              { 
                  name: 'Trả hàng',
                  data: _.map(dataChart, 'total_return_qty')
              }
          ]
        };
        
        if(this.selectedReportType == 1) {
          ret.yAxis = {
            title: {
              text: 'Tổng tiền'
            }
          };
          ret.series = [
            { 
              name: 'Xuất hàng',
              data: _.map(dataChart, 'total_receipt_amount')
            },
            { 
              name: 'Trả hàng',
              data: _.map(dataChart, 'total_return_amount')
            }
          ];
        }
        else if(this.selectedReportType == 2){
          ret.yAxis = {
            title: {
              text: 'Số sản phẩm'
            }
          };
          ret.series = [
            { 
              name: 'Xuất hàng',
              data: _.map(dataChart, 'total_receipt_qty')
            },
            { 
              name: 'Trả hàng',
              data: _.map(dataChart, 'total_return_qty')
            }
          ];
        }
        else {
          ret.yAxis = {
            title: {
              text: 'Số đơn'
            }
          };
          ret.series = [
            { 
              name: 'Xuất hàng',
              data: _.map(dataChart, 'total_receipt')
            },
            { 
              name: 'Trả hàng',
              data: _.map(dataChart, 'total_return')
            }
          ];
        }
        return ret;
    },
    orderChart() {
        let dataChart =  _.sortBy(this.summaries,'report_date');
        let ret = {
          chart: { type: 'column' },
          title: { text: 'Bán hàng' },
          credits: { enabled: false },
          tooltip: {
            shared: true, 
            formatter: function () {
              return parseFloat(this.y.toFixed(2)).toLocaleString();
            }
          },
          xAxis: {
              categories: _.map(dataChart, function(x) {return x.report_date.toString().replace(/(\d{4})(\d{2})(\d{2})/, "$3-$2-$1")})
          },
          yAxis: {
              title: {
                  text: 'Tổng tiền'
              }
          },
          plotOptions: {
              line: {
                  dataLabels: {
                      enabled: true
                  }
              },
              series: {
                pointWidth: 30
              }
          },
          series: [
              { 
                  name: 'Bán hàng',
                  data: _.map(dataChart, 'total_order_amount')
              }
          ]
        };
        if(this.selectedReportType == 1) {
          ret.yAxis = {
            title: {
              text: 'Tổng tiền'
            }
          };
          ret.series = [
            { 
              name: 'Bán hàng',
              data: _.map(dataChart, 'total_order_amount')
            }
          ];
        }
        else if(this.selectedReportType == 2){
          ret.yAxis = {
            title: {
              text: 'Số sản phẩm'
            }
          };
          ret.series = [
            { 
              name: 'Bán hàng',
              data: _.map(dataChart, 'total_order_qty')
            }
          ];
        }
        else {
          ret.yAxis = {
            title: {
              text: 'Số đơn'
            }
          };
          ret.series = [
            { 
              name: 'Bán hàng',
              data: _.map(dataChart, 'total_order')
            }
          ];
        }

        return ret;
    },
    paymentChart() {
        let dataChart =  _.sortBy(this.summaries,'report_date');
        let ret = {
            chart: { type: 'column' },
            title: { text: 'Thanh toán' },
            credits: { enabled: false },
            tooltip: {
              shared: true, 
              formatter: function () {
                return parseFloat(this.y.toFixed(2)).toLocaleString();
              }
            },
            xAxis: {
                categories: _.map(dataChart, function(x) {return x.report_date.toString().replace(/(\d{4})(\d{2})(\d{2})/, "$3-$2-$1")})
            },
            yAxis: {
                title: {
                    text: 'Tổng tiền'
                }
            },
            plotOptions: {
              line: {
                dataLabels: {
                    enabled: true
                }
              },
              series: {
                pointWidth: 30
              }
            },
            series: [
                { 
                    name: 'Thanh toán',
                    data: _.map(dataChart, 'total_payment')
                }
            ]
          };

        return ret;
    },
    topProductChart() {
        let dataChart = this.top_products;
        let ret = {}
        if(this.selectedReportType == 1) {
          ret = {
            chart: { type: 'bar' },
            title: { text: 'Doanh thu' },
            credits: { enabled: false },
            tooltip: {
              shared: true, 
              formatter: function () {
                return parseFloat(this.y.toFixed(2)).toLocaleString();
              }
            },
            xAxis: {
                categories: _.map(dataChart, function(x) {return x.name})
            },
            yAxis: {
                title: {
                    text: 'Doanh thu'
                }
            },
            plotOptions: {
                line: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            series: [
                { 
                    name: 'Doanh thu',
                    data: _.map(dataChart, 'total'),
                    dataLabels: {
                      enabled: true,
                      formatter: function () {
                        return parseFloat(this.y.toFixed(2)).toLocaleString();
                      }
                    },
                    dataSorting: {
                      enabled: true
                    },
                }
            ]
          };
        }
        else {
          ret = {
            chart: { type: 'bar' },
            title: { text: 'Số lượng' },
            credits: { enabled: false },
            tooltip: {
              shared: true, 
              formatter: function () {
                return parseFloat(this.y.toFixed(2)).toLocaleString();
              }
            },
            xAxis: {
              categories: _.map(dataChart, function(x) {return x.name})
            },
            yAxis: {
                title: {
                    text: 'Số lượng'
                }
            },
            plotOptions: {
                line: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            series: [
                { 
                    name: 'Số lượng',
                    data: _.map(dataChart, 'total'),
                    dataLabels: {
                      enabled: true,
                      formatter: function () {
                        return parseFloat(this.y.toFixed(2)).toLocaleString();
                      }
                    },
                }
            ]
          };
        }
        return ret;
    }
  },
  methods: {
    refresh_report() {
      this.$store.dispatch("reports/get_summary_report", this.filter_params);
      this.$store.dispatch("reports/get_top_product_report", this.filter_params );          
    },
    gotoDetail(url) {
      let date_range = {
        // 'start_date': `${moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT).replace(' ', 'T')}.000Z`, 
        // 'end_date': `${moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT).replace(' ', 'T')}.000Z`
      }
      if(url == 'khach-hang') {
        this.$router.push({
            name: "Customers",
            params: {
              title: `Khách hàng`
            }
        });
      }
      else if(url == 'ban-hang') {
        this.$router.push({
            name: "Orders",
            query: date_range,
            params: {
              title: `Đơn bán`
            }
        });
      }
      else if(url == 'xuat-hang') {
        this.$router.push({
            name: "ExportOrders",
            query: date_range,
            params: {
              title: `Đơn xuất`
            }
        });
      }
      else if(url == 'tra-hang') {
        this.$router.push({
            name: "Returns",
            query: date_range,
            params: {
              title: `Trả hàng`
            }
        });
      }
      else if(url == 'thanh-toan') {
        this.$router.push({
            name: "Recharges",
            query: date_range,
            params: {
              title: `Thanh toán`
            }
        });
      }
    }
  },
  mounted() {
    this.refresh_report();
  }
}
</script>